export default {
  typeMessage: 'Digita il messaggio...',
  send: 'Invia',
};
